var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({staticClass:"jz-button",class:[
    _vm.data.class,
    _vm.data.staticClass,
    {
      'jz-primary': _vm.props.primary,
      'jz-primary-alternate': _vm.props.primaryAlternate,
      'jz-rounded': _vm.props.rounded
    }
  ]},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default",[_vm._v("Do not forget to add some content")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }